<template>
    <div class="collection-gift-item-wrapper" v-if="christmas">
        <div class="collection-gift-item" v-for="(item, index) in collectionsList" :key="index">
            <div class="gift-bottle-img" :style="getImgUrl(item.picture)"></div>
            <div class="gift-wrapper">
                <div class="gift-wrapper-row1">
                    <div class="gift-wrapper-row1-wine">
                        <div class="gift-wrapper-row1-wine1">
                            <div class="gift-flag" :style="{ background: `url(${item.wines[0].countryFlagUrl}) no-repeat center` }"></div>
                            <h3 class="gift-title">{{item.title}}</h3>
                        </div>
                        <div class="gift-wrapper-row1-wine2">
                            <div class="gift-wrapper-row1-wine2-text">{{item.wines[0].regionName}}</div>
                            <div class="gift-wrapper-row1-wine2-text">
                                <div :class="item.wines[0].colorId == 1 ? 'redwine' : (item.wines[0].colorId == 2 ? 'whitewine' : 'champagne')" ></div> {{ $t(item.wines[0].color.toLowerCase()) }}, {{item.wines[0].appellation}}
                            </div>
                        </div>
                    </div>
                    <div class="gift-wrapper-row1-price">
                        <div class="gift-wrapper-row1-price1">{{ $t("christmas-gift12") }}</div>
                        <div class="gift-wrapper-row1-price2">{{formatPrice(item.price.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                        <div class="gift-wrapper-row1-price3">{{ $t("christmas-gift13") }} <span>{{item.wines[0].caseSize.replace('1x','')}}l</span></div>
                    </div>
                    <div v-if="mobileCheck" class="gift-wrapper-row2">{{item.subtitle}}</div>
                    <div class="gift-wrapper-row1-btn">
                        <button v-if="item.availableQuantity !== 0" class="gift-cart-btn" v-on:click.stop="() => { addCollectionToCart(item) }">{{ $t('add-basket') }}</button>
                        <div v-else class="gift-sold-label">{{ $t('sold-out') }}</div>
                    </div>
                </div>
                <div class="gift-wrapper-line"></div>
                <div v-if="!mobileCheck" class="gift-wrapper-row2">{{item.subtitle}}</div>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-if="(mobileCheck || windowWidth < 1025) && useSlider" class="home-more-collections">
            <swiper name="HomeMoreCollections" ref="infoSwiper" :options="swiperOptions">
                <swiper-slide v-for="(item, index) in collectionsList" :key="index">
                    <v-card class="collection-item">
                        <v-card-text>
                            <div :class="{ 'additional-info': true, 'last-item': index===2 || index===5 }">
                                <div class="additional-info-subtitle">{{ $t('collections1') }}</div>
                                <div class="additional-info-title">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                                <div class="additional-info-wines" v-for="(wine, wineIndex) in item.wines" :key="wineIndex">
                                    <div class="additional-info-title">
                                        <div class="country-flag" :style="{ background: `url(${wine.countryFlagUrl}) no-repeat center` }"></div>
                                        <div v-if="wine.displayWineName">
                                            <div class="wine-vintage-name">{{wine.displayWineName}}</div>
                                        </div>
                                        <div v-else-if="wine.wineName">
                                            <div class="wine-vintage-name">{{wine.vintage}} {{wine.wineName}}</div>
                                        </div>
                                        <div v-else>
                                            <div class="wine-vintage-name">{{wine.vintage}} {{wine.producerName}} asd</div>
                                        </div>
                                    </div>
                                    <div class="additional-info-subtitle">{{wine.caseQuantity}} {{wine.caseQuantity > 1 ? 'cases' : 'case'}} of {{wine.caseSize}}</div>
                                </div>
                                <div class="arrow-right"></div>
                                <div class="arrow-left"></div>
                            </div>
                            <div class="header-img" :style="getImgUrl(item.picture)"></div>

                            <div class="background-shadow" v-on:click="() => { openCollection(item) }">
                                <h3 class="collection-header">{{item.title}}</h3>
                            </div>

                            <div class="investment-horizon-wrapper">
                                <div class="investment">{{ $t('collections1') }}</div>
                                <div :class="{'investments-percentages': true, 'investments-percentages-2': item.investmentHorizon === 2, 'investments-percentages-3': item.investmentHorizon === 3}">
                                    <div class="collection-percent"></div>
                                    <div class="collection-percent"></div>
                                    <div class="collection-percent"></div>
                                </div>
                                <div class="investment-years">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                            </div>

                            <div class="collection-subtitle">{{item.subtitle}}</div>

                            <div class="collection-price-wrapper">
                                <div class="investments-wrapper-left">
                                    <div class="collection-price">{{formatPrice(item.price.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                                    <div class="collections-save">{{ $t('collections5') }} {{formatPrice(item.youSave.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                                </div>
                                <div class="investments-wrapper-right">
                                    <div v-if="item.availableQuantity !== 0">
                                        <button :class="$i18n.locale.toLowerCase() === 'fr' ? 'cart-btn-fr' : ($i18n.locale.toLowerCase() === 'it' ? 'cart-btn-it' : 'cart-btn')" v-on:click="() => { addCollectionToCart(item) }">{{ $t('add-basket') }}</button>
                                    </div>
                                    <div v-else>
                                        <div :class="$i18n.locale.toLowerCase() === 'fr' ? 'sold-label-fr' : 'sold-label'">{{ $t('sold-out') }}</div>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
        <div v-else>
            <v-card class="collection-item" v-for="(item, index) in collectionsList" :key="index">
                <v-card-text>
                    <div :class="{ 'additional-info': true, 'last-item': index===2 || index===5 }">
                        <div class="additional-info-subtitle">{{ $t('collections1') }}</div>
                        <div class="additional-info-title">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                        <div class="additional-info-wines" v-for="(wine, wineIndex) in item.wines" :key="wineIndex">
                            <div class="additional-info-title">
                                <div class="country-flag" :style="{ background: `url(${wine.countryFlagUrl}) no-repeat center` }"></div>
                                <div v-if="wine.displayWineName">
                                    <div class="wine-vintage-name">{{wine.displayWineName}}</div>
                                </div>
                                <div v-else-if="wine.wineName">
                                    <div class="wine-vintage-name">{{wine.vintage}} {{wine.wineName}}</div>
                                </div>
                                <div v-else>
                                    <div class="wine-vintage-name">{{wine.vintage}} {{wine.producerName}} asd</div>
                                </div>
                            </div>
                            <div class="additional-info-subtitle">{{wine.caseQuantity}} {{wine.caseQuantity > 1 ? 'cases' : 'case'}} of {{wine.caseSize}}</div>
                        </div>
                        <div class="arrow-right"></div>
                        <div class="arrow-left"></div>
                    </div>
                    <div class="header-img" :style="getImgUrl(item.picture)"></div>

                    <div class="background-shadow" v-on:click="() => { openCollection(item) }">
                        <h3 class="collection-header">{{item.title}}</h3>
                    </div>

                    <div class="investment-horizon-wrapper">
                        <div class="investment">{{ $t('collections1') }}</div>
                        <div :class="{'investments-percentages': true, 'investments-percentages-2': item.investmentHorizon === 2, 'investments-percentages-3': item.investmentHorizon === 3}">
                            <div class="collection-percent"></div>
                            <div class="collection-percent"></div>
                            <div class="collection-percent"></div>
                        </div>
                        <div class="investment-years">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                    </div>

                    <div class="collection-subtitle">{{item.subtitle}}</div>

                    <div class="collection-price-wrapper">
                        <div class="investments-wrapper-left">
                            <div class="collection-price">{{formatPrice(item.price.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                            <div class="collections-save">{{ $t('collections5') }} {{formatPrice(item.youSave.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                        </div>
                        <div class="investments-wrapper-right">
                            <div v-if="item.availableQuantity !== 0">
                                <button :class="$i18n.locale.toLowerCase() === 'fr' ? 'cart-btn-fr' : ($i18n.locale.toLowerCase() === 'it' ? 'cart-btn-it' : 'cart-btn')" v-on:click="() => { addCollectionToCart(item) }">{{ $t('add-basket') }}</button>
                            </div>
                            <div v-else>
                                <div :class="$i18n.locale.toLowerCase() === 'fr' ? 'sold-label-fr' : 'sold-label'">{{ $t('sold-out') }}</div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {AOrders, AUser} from '@/store/actions';
    import {MOrders} from "@/store/mutations";
    import {GCommon, GOrders, GUser} from "@/store/getters";
    import { directive } from "vue-awesome-swiper";

export default {
    name: "HomeMoreCollections",
    props: ['collectionsList', 'useSlider', 'christmas'],
    directives: {
        swiper: directive
    },
    data () {
        return {
            windowWidth: null,
            valid: true,
            deleteDialog: false,
            editDialog: false,
            editAddressSuccess: {
                visible: false,
                text: 'Address added successfully!'
            },
            editAddressFail: {
                visible: false,
                text: 'Please review again all the information and try again!'
            },
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                dynamicBullets: true
            }
        }
    },
    computed: {
        ...mapGetters({
            cartItemsList: GOrders.GET_CART_ITEMS,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            addressList: GUser.GET_ADDRESSES,
        }),
        billingAddress() {
            let address = null;

            this.addressList.forEach(element => {
                if (element.type === 1 || element.type === 3) {
                    address = element;

                    if ((element.countryId === 138 || element.countryId === 72) || element.vat === "") {
                        this.VATvalue = 0.2
                    }
                }
            });

            return address;
        },
    },
    methods: {
        formatPrice(price) {
            return `€${price}`
        },
        openCollection(item) {
            if (this.goToDetailsPage) {
                return;
            }
            this.goToDetailsPage = true;
            let wineCollectionsView = this;
            this.$store.dispatch(AOrders.GET_COLLECTION_DETAILS, { id: item.id, lang: this.$i18n.locale }).then(() => {
                setTimeout(function() {
                    wineCollectionsView.goToDetailsPage = false
                }, 800);
                this.$store.dispatch(AUser.GET_USER_COMMISSION);
                this.$store.dispatch(AUser.GET_ADDRESSES);
                this.$router.push(this.localePath({ path: `/collection-details/${item.id}` }));
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            })
        },
        addCollectionToCart (collection) {
            let availableInCartGifts = this.cartItemsList.filter(item => item.christmasGift === true);

            if ((availableInCartGifts.length && typeof this.christmas === 'undefined') || (this.cartItemsList.length && !availableInCartGifts.length && this.christmas)) {
                this.$nuxt.$emit('carterror', !!this.christmas);
                return;
            }

            let _payload = {};
            let availableInCart = this.cartItemsList.filter(item => item.id === collection.id);

            if (availableInCart.length) {
                if (this.christmas) {
                    if (availableInCart.length >= collection.availableQuantity) {
                        alert('There are not enough collections on the market');
                        return;
                    }
                } else {
                    if (availableInCart[0].unitsCount >= collection.availableQuantity) {
                        alert('There are not enough collections on the market');
                        return;
                    }
                }
            }

            this.$gtm.push({ ecommerce: null });
            this.$gtm.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "EUR",
                    value: collection.price,
                    purchase: {
                        price: collection.price,
                        id: Math.floor(Math.random() * 10000) + 1
                    },
                    items: [
                        {
                            item_id: collection.id,
                            item_name: collection.title,
                            coupon: "",
                            discount: 0,
                            index: 0,
                            item_brand: "Vindome Wine Collection",
                            item_category: "Wine collection",
                            item_list_id: "wine_collections",
                            price: collection.price,
                            quantity: 1
                        }
                    ]
                }
            });

            _payload.availableQuantity = collection.availableQuantity;
            _payload.collectionOrderIds = collection.collectionOrderIds;
            _payload.investmentHorizon = collection.investmentHorizon;
            _payload.isEnPrimeur = collection.isEnPrimeur;
            _payload.id = collection.id;
            _payload.price = collection.price;
            _payload.title = collection.title;
            _payload.picture = collection.picture;
            _payload.unitsCount = 1;
            _payload.youSave = collection.youSave;
            _payload.totalCases = 0;
            _payload.christmasGift = !!this.christmas;
            _payload.wines = [];

            if (!!this.christmas) {
                _payload.sameAsPrevious = false;
                _payload.sameAsBilling = !!this.billingAddress;
                _payload.address = {};
                _payload.address.firstName = '';
                _payload.address.lastName = '';
                _payload.address.street = '';
                _payload.address.zipCode= '';
                _payload.address.city = '';
                _payload.address.country = '';
                _payload.address.country2 = {};
                _payload.address.message = 'Summer vibes!';
            }

            collection.wines.forEach(element => {
                let _wine = {};
                _wine.caseQuantity = element.caseQuantity;
                _wine.pricePerCase = element.pricePerCase;
                _payload.wines.push(_wine);
                _payload.totalCases += element.caseQuantity;
            });
            this.$store.commit(MOrders.SET_COLLECTION_CART, { collections: _payload, addRemove: true, resetCart: false });
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
    }
}
</script>

<style scoped>
    .collection-gift-item-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        align-self: stretch;
    }
    .collection-gift-item {
        min-height: 254px;
        width: 100%;
        position: relative;
    }
    .gift-bottle-img {
        width: 168px;
        height: 230px;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
        background-position: center;
    }
    .gift-wrapper {
        display: flex;
        padding: 24px 40px 24px 168px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 8px;
        border: 1px solid #CCC;
        background: white;
        margin-top: 54px;
        min-height: 200px;
    }
    .gift-wrapper-row1 {
        display: flex;
        align-items: flex-start;
        gap: 40px;
        align-self: stretch;
    }
    .gift-wrapper-row1-wine {
        display: flex;
        width: 391px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .gift-wrapper-row1-price {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
    }
    .gift-wrapper-row1-price1 {
        color: #707070;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%;
    }
    .gift-wrapper-row1-price2 {
        color: #000;
        font-family: Montserrat, sans-serif;
        font-size: 19px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
    }
    .gift-wrapper-row1-price3 {
        color: #707070;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
    }
    .gift-wrapper-row1-price3 span {
        color: #000;
    }
    .gift-wrapper-row1-btn {
        display: flex;
        width: 170px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .gift-cart-btn, .gift-sold-label {
        display: flex;
        height: 36px;
        padding: 8px 16px;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 8px;
        background: #004F7F;
        color: white;
        font-family: Montserrat, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }
    .gift-sold-label {
        background: #8E8E93;
        cursor: not-allowed;
    }
    .gift-wrapper-row1-wine2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .gift-wrapper-row1-wine1 {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
    }
    .gift-flag {
        display: flex;
        margin-top: 2px;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        width: 24px;
        height: 14px;
        background-size: cover !important;
    }
    .gift-title {
        color: #404040;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
    }
    .gift-wrapper-row1-wine2-text {
        color: #000;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
    }
    .redwine {
        background: url('../../assets/red.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .whitewine {
        background: url('../../assets/white.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .champagne {
        background: url('../../assets/rose.png') no-repeat center right;
        background-size: contain;
        width: 9px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        float: left;
    }
    .gift-wrapper-line {
        height: 1px;
        background: #cccccc;
        width: 100%;
    }
    .gift-wrapper-row2 {
        color: #000;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 20px;
    }

    .country-flag {
        width: 30px;
        height: 15px;
        background-size: contain !important;
        display: block;
        top: 1px;
        position: absolute;
    }
    .sold-label {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 130px;
        height: 36px;
        background: #efefef;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #000;
        margin-top: 6px;
        text-align: center;
        float: right;
    }
    .sold-label-fr {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 130px;
        height: 36px;
        background: #efefef;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #000;
        margin-top: 34px;
        text-align: center;
        float: right;
    }
    .additional-info {
        display: none;
        padding: 18px;
        background: #FFFFFF;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        -moz-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
        position: absolute;
        left: calc(100% - 14px);
        z-index: 3;
        width: 100%;
    }
    .additional-info.last-item {
        left: unset;
        right: calc(100% - 14px);
    }
    .arrow-right {
        content: '';
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        left: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }
    .arrow-left {
        content: '';
        display: none;
        vertical-align: middle;
        margin: auto;
        position: absolute;
        top: 0;
        right: -8px;
        bottom: 0;
        width: 15px;
        height: 15px;
        background: #fff;
        border-top: 1px solid #ccc;
        border-right: 1px solid #ccc;
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }
    .additional-info.last-item .arrow-right {
        display: none;
    }
    .additional-info.last-item .arrow-left {
        display: block;
    }

    .additional-info-wines {
        margin-top: 16px;
    }
    .additional-info-subtitle {
        font-family: Roboto, sans-serif;
        size: 14px;
        line-height: 19px;
        color: #707070;
    }
    .additional-info-title {
        font-family: Roboto, sans-serif;
        size: 16px;
        line-height: 19px;
        color: #000000;
        font-weight: 500;
        position: relative;
    }
    .  {
        width: 30px;
        height: 15px;
        background-size: contain;
        display: block;
        top: 1px;
        position: absolute;
    }
    .wine-vintage-name {
        display: inline-block;
        text-indent: 40px;
    }
    .background-shadow {
        background: linear-gradient(180deg, rgba(0, 48, 77, 0) 0%, #00304D 100%);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 188px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .background-shadow:hover {
        cursor: pointer;
    }
    .collection-item {
        display: inline-block;
        width: calc((100% - 48px)/3);
        margin-right: 24px;
        margin-bottom: 46px;
        border-radius: 8px;
        background: transparent;
        vertical-align: top;
        box-shadow: none !important;
    }
    .collection-item:hover {
        cursor: pointer;
    }
    .collection-item:hover .additional-info {
        display: block;
    }
    .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
    .header-img {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        width: 100%;
        height: 188px;
        position: relative;
        background-size: cover;
        background-position-y: center;
    }
    .collection-header {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        color: #ffffff;
        position: absolute;
        bottom: 16px;
        left: 16px;
        white-space: pre-line;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        z-index: 2;
        width: calc(100% - 32px);
    }
    .background-shadow:hover .collection-header {
        color: var(--brand)
    }
    .collection-subtitle {
        height: 66px;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #002840;
        margin: 8px 0 16px;
    }
    .investments-wrapper-left,
    .investments-wrapper-right {
        display: inline-block;
        width: calc(50% - 2px);
        vertical-align: top;
    }
    .investments-wrapper-right {
        text-align: right;
    }
    .investments-percentages {
        height: 4px;
    }
    .investments-percentages .collection-percent {
        display: inline-block;
        width: calc((100% - 8px) / 3);
        background: rgba(0, 0, 0, 0.16);
        height: 4px;
        border-radius: 2px;
        vertical-align: top;
    }
    .investments-percentages .collection-percent:nth-child(1),
    .investments-percentages.investments-percentages-2 .collection-percent:nth-child(2),
    .investments-percentages.investments-percentages-3 .collection-percent:nth-child(2),
    .investments-percentages.investments-percentages-3 .collection-percent:nth-child(3) {
        background: #E5CB87;
    }
    .cart-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: white;
        margin-top: 6px;
    }
    .cart-btn-it {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 4px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 13px;
        color: white;
        margin-top: 6px;
    }
    .cart-btn-fr {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 145px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: white;
        margin-top: 34px;
    }
    .collection-price {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: #002840;
        margin-bottom: 2px;
    }
    .collections-save {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #002840;
    }
    .investment-horizon-wrapper {
        height: 64px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 0 0 8px 8px;
        padding: 8px;
    }
    .investment {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #002840;
    }


    @media(min-width: 768px) and (max-width: 1024px) {
        .collection-item {
            width: 380px;
            margin: 0 auto 20px;
            box-sizing: border-box;
            display: block;
        }
    }

    @media(max-width: 767px) {
        .swiper-button-next,
        .swiper-button-prev {
            display: none;
        }
        .collection-item {
            width: 100%;
            margin-right: 0;
            margin-left: 0;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
        .collection-item:hover .additional-info, .gift-wrapper-line {
            display: none;
        }
        .gift-bottle-img {
            width: 40px;
            height: 160px;
            left: calc((100% - 40px) / 2);
        }
        .gift-wrapper {
            padding: 125px 16px 16px 16px;
            height: auto;
        }
        .collection-gift-item {
            height: auto;
        }
        .gift-wrapper-row1 {
            flex-direction: column;
            gap: 16px;
        }
        .gift-wrapper-row1-btn, .gift-wrapper-row1-wine {
            width: 100%;
        }
    }
</style>

<style>
    .collection-item .v-card__text {
        padding: 0;
    }
    .home .home-more-collections .swiper-container {
        height: 380px !important;
        margin-bottom: 32px;
    }
</style>
